
import { supabase as supabaseClient } from '@/integrations/supabase/client';

// Export the client for use throughout the app
export const supabase = supabaseClient;
